import * as React  from 'react';
import { useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';
import CheckBox from '../Checkbox';
// import FieldRenderingEngine from "../FieldRenderingEngine";
import FieldDisplayEngine, { sanitizeRichTextForListing } from "../FieldDisplayEngine";
import { ListingViewConstants } from '../../common/constants';
import {getResolutionName} from '../../containers/WorkkardDetail/utils';
import { RenderEngineKey } from '../../containers/WorkkardDetail/constants';
import UserImage from '../UserImage/index';
import { useModules } from '../../utils/modules';

const renderCustomFields = (data, rendertype, includeFields = []) =>{
    const fields = rendertype === ListingViewConstants.Activity ? data?.workkardInfo : data?.customFields;
    if (fields && fields.length > 0)
    {
        return <FieldDisplayEngine data={fields} renderLocation={'grid'}
        renderType={'workkard'} includeFields={includeFields} {...data}/>
    }
    else {
        return "-";
    }
}

const renderCarrierClaimNumber = (data)=> {
    let carrierClaimNumberObj  =  data && data.customFields.find(item =>  item.FieldGroup === RenderEngineKey.CarrierClaimNumber);
    let carrierClaimNumber =  carrierClaimNumberObj ? carrierClaimNumberObj.Value : '-';
    return <li>{carrierClaimNumber}</li>;
}

const ListingCell = (props) => {
    const { data, extraData, onCellClick } = props;
    const { isModuleEnabled } = useModules();
    let timeOut=null;
    let showCarrierClaim = extraData.hasOwnProperty('showCarrierClaim')? extraData.showCarrierClaim : false;
    const isChecked = extraData.selectedids && extraData.selectedids.includes(data.activityId)
    const isActUnassignedSelected = extraData.listType === ListingViewConstants.Activity && extraData.selectedTab === "unassigned"
    let status ;
    let progress = '';
    if (extraData.listType === ListingViewConstants.Activity) {
        status= getResolutionName(data.resolutionForDisplay);
        if((data.resolutionForDisplay === 'IN PROGRESS'|| data.resolutionForDisplay === 'InProgress') && data.progress){
            progress = ` (${data.progress}% DONE)`
        }
    }
    else {
        status=data.WorkkardStatusForDisplay && data.WorkkardStatusForDisplay.toLowerCase();
    }

    const cachedAssigneeUser = useSelector((state) =>
        data.activityAssigneeId ? state.userList?.[data.activityAssigneeId] : null);
    const cachedAssigneeOrg = useSelector((state) =>
        !data.activityAssigneeId && data.assigneeOrgId ? state.orgList?.[data.assigneeOrgId] : null);

    const assigneeDisplayName = data.activityAssigneeId
        ? (data.activityAssignee ||
            `${cachedAssigneeUser?.first_name || cachedAssigneeUser?.firstName || ''} ${cachedAssigneeUser?.last_name || cachedAssigneeUser?.lastName || ''}`.trim())
        : (data.activityAssignee ||
            cachedAssigneeOrg?.OrganizationName || cachedAssigneeOrg?.name || cachedAssigneeOrg?.organization_name);

    const ownerId = data.sponsorId || data.activityOwnerId;
    const cachedOwnerUser = useSelector((state) =>
        ownerId ? state.userList?.[ownerId] : null);
    const cachedOwnerOrg = useSelector((state) =>
        !ownerId && data.ownerOrgId ? state.orgList?.[data.ownerOrgId] : null);

    const ownerDisplayName = ownerId
        ? (data.sponsorName || data.activityOwnerName || data.workkardOwner ||
            `${cachedOwnerUser?.first_name || cachedOwnerUser?.firstName || ''} ${cachedOwnerUser?.last_name || cachedOwnerUser?.lastName || ''}`.trim())
        : (data.sponsorName || data.activityOwnerName || data.workkardOwner ||
            cachedOwnerOrg?.OrganizationName || cachedOwnerOrg?.name || cachedOwnerOrg?.organization_name);

    const handleMouseAssignee=e=>{
                                const targetRect = e.currentTarget.getBoundingClientRect();
                                let assigneeuserdata = {};

                                if(data.IsAssigneeDeleted){
                                    assigneeuserdata={ id: data.activityAssigneeId, type: 'user' }
                                } else if(data.accessToOrgIds && data.accessToOrgIds.includes(data.assigneeOrgId)) {
                                    if(data.activityAssigneeId){
                                        assigneeuserdata={ id: data.activityAssigneeId, type: 'user' }
                                    }else if(data.IsAssigneeOrganizationDeleted){
                                        assigneeuserdata={ id: data.assigneeOrgId, type: 'org' }
                                    }else{
                                        assigneeuserdata={ id: data.assigneeOrgId, type: 'org' }
                                    }
                                }   
                                else{
                                    assigneeuserdata={ id: data.assigneeOrgId, type: 'org' }
                                }
                                // if(data.activityAssigneeId){
                                //     assigneeuserdata = { id: data.activityAssigneeId, type: 'user' }
                                // }
                                // else if (data.accessToOrgIds.includes(data.assigneeOrgId) && data.isAssigneeSysUser) {
                                //     assigneeuserdata = { id: data.activityAssigneeId, type: 'user' }
                                // } else if (data.accessToOrgIds.includes(data.assigneeOrgId)) {
                                //     assigneeuserdata = { id: data.activityAssigneeId || data.assigneeOrgId, type: data.activityAssigneeId ? 'user' : 'org' }
                                // } else {
                                //     assigneeuserdata = { id: data.assigneeOrgId, type: 'org' }
                                // }
                                const payload = {
                                    target: targetRect,
                                    userId: assigneeuserdata.id,
                                    type: assigneeuserdata.type,
                                    position: 'left'
                                }
                                timeOut = setTimeout(() => onCellClick(payload),500)
                        
                            }
    
    const handleMouseSponsor=(e)=>{
                            const targetRect = e.currentTarget.getBoundingClientRect();
                            let owneruserdata = {};
                            if (data.sponsorId || (data.accessToOrgIds && data.accessToOrgIds.includes(data.ownerOrgId))) {
                                owneruserdata = { id: data.sponsorId || data.activityOwnerId, type: 'user' }
                            } else {
                                owneruserdata = { id: data.ownerOrgId, type: 'org' }
                            }
                            const payload = {
                                target: targetRect,
                                userId: owneruserdata.id,
                                type: owneruserdata.type,
                                position: 'left'
                            }
                            timeOut = setTimeout(() => onCellClick(payload),500)
                    
                        }

    return(
        <ul key={data.activityId} className="nowWrap">
            <li className={extraData.showCheckbox && isActUnassignedSelected ? "rowFlex":""}>
                {extraData.showCheckbox &&  isActUnassignedSelected && 
                <CheckBox item={{id:data.activityId, checked:isChecked}} handleCheckbox={(evt) => extraData.handleCheckboxChange(evt, false, data.activityId)} />    
                }
                {extraData.listType === ListingViewConstants.Activity?(
                <div className="colFlex">
                    <p><a href={`/getclmdetail?cId=${data.workkardId}`}><span className="orange">{data.workkardNumber}</span></a></p>
                    <p><a href={`/getclmdetail?cId=${data.workkardId}&actId=${data.activityId}`}>{data.activityName}</a></p>
                    {/* to implement after moving Diary detail in react due to page not refreshing after clicking wk in Topbar   
                        <p><Link to={`/getclmdetail?cId=${data.workkardId}`} onClick={(e) => handleTBSLinkClick(e)}><span className="orange">{data.workkardNumber}</span></Link></p>
                        <p><Link to={`/getclmdetail?cId=${data.workkardId}&actId=${data.activityId}`} onClick={(e) => handleTBSLinkClick(e)}>{data.activityName}</Link></p>
                    */}
                </div>                
                )
                :
                    data.workkardNumber && 
                    <React.Fragment>
                        <a href={`/getclmdetail?cId=${data.workkardId}`}><span className="status wkNumber mr">{data.workkardNumber}</span></a>
                        {/* to implement after moving Diary detail in react due to page not refreshing after clicking wk in Topbar
                        <Link to={`/getclmdetail?cId=${data.workkardId}`} onClick={(e)=>handleTBSLinkClick(e)}>
                            <span className="status wkNumber mr">{data.workkardNumber}</span>
                        </Link>
                        */}
                        <div className={"status " + status}>
                            {status && (status.charAt(0).toUpperCase() + status.slice(1))}
                        </div>
                    </React.Fragment>
                }
            </li>
            {
                showCarrierClaim && <li>{renderCarrierClaimNumber(data)}</li>
            }
            
            <li>
                {renderCustomFields(data, extraData.listType, [RenderEngineKey.PropertyLocation,RenderEngineKey.CustomerName ])}
            </li>
            {
                showCarrierClaim ? <li>{data.workkardTitle}</li>  :
                <li>{extraData.listType === ListingViewConstants.Activity ?
                     <div className={`status ${getResolutionName(status.toLowerCase(),true)}`}>
                        {status.toUpperCase()}{progress}</div> : <span dangerouslySetInnerHTML={{ __html: sanitizeRichTextForListing(data.workkardSummary) || '-' }} />}
                {extraData.listType === ListingViewConstants.Activity ? <div>due on <span className="red">{data.dueOn}</span></div>:null}</li>
            }
            
            <li>
                <div className="rowFlex userGroup">
                    <div className="userPic userPicIcon" onMouseEnter={handleMouseSponsor} onMouseLeave={()=>{clearTimeout(timeOut)}}>
                          <UserImage profileUrl={data.sponsorImage || data.activityOwnerImage || data.workkardOwnerImage} profileName={ownerDisplayName}/>

                    </div>
                    <div className="userInfo">
                        {ownerDisplayName}
                    </div>
                </div>
            </li>
            {!(extraData.listType !== ListingViewConstants.Activity && !isModuleEnabled("workkards.listing.carrier")) &&
            <li>
                {extraData.listType === ListingViewConstants.Activity ? (<div className="rowFlex userGroup">
                    <div className="userPic userPicIcon" onMouseEnter={handleMouseAssignee} onMouseLeave={()=>{clearTimeout(timeOut)}}>
                        <UserImage profileUrl={data.activityAssigneeImage} profileName={assigneeDisplayName}/>


                    </div>
                    <div className="userInfo">
                        {assigneeDisplayName}
                    </div>
                </div>)
                :
                (
                    data.carrierName && data.carrierName.trim().length >0 ?
                    data.carrierName
                    :
                    "-"
                )
            }
            </li>
            }
        </ul>
    )
}


export default ListingCell;